var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"app-calendar"},[_c('FullCalendar',{ref:"fullCalendar",attrs:{"eventOrder":['eventOrder'],"default-view":"dayGridMonth","header":{
                  left: 'prev,next today',
                  center: 'title',
                  right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
                },"button-text":{
                  today: 'Today',
                  month: 'Month',
                  week: 'Week',
                  day: 'Day',
                  list: 'List',
                  prev: 'Prev',
                  next: 'Next',
                },"bootstrap-font-awesome":false,"editable":false,"droppable":false,"plugins":_vm.calendarPlugins,"events":_vm.events,"weekends":_vm.calendarWeekends,"theme-system":_vm.themeSystem},on:{"eventClick":_vm.editEvent}})],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }